module.exports = __webpack_public_path__ + "17c50b97717a2f8462850f521597a191.pdf";